import React from 'react';
import { t } from 'i18n';

import Icon from 'Components/Base/Icon';

const CodeExpiresIn = () => {
  return <div className="code_input__expires_in">
    <Icon name="information" />
    {t('code_expires_in', { scope: 'base' })}
  </div>;
};

export default CodeExpiresIn;
